
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import SystemSubjectsContent from "./components/SystemSubjectsContent.vue";

export default defineComponent({
  name: "SystemSubjectsPage",
  components: {
    BreadCrumb,
    SystemSubjectsContent,
  },
});
